<template>
  <v-navigation-drawer
    v-model="showDrawer"
    temporary
    app
  >
    <v-list>
      <v-list-item-group active-class="deep-purple--text text--accent-4">
        <v-list-item
          v-if="!isLoggedIn"
          :to="{ name: 'LoginPage' }"
        >
          <v-list-item-title>Connexion</v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="isLoggedIn"
          :to="{ name: 'projects-list-remote' }"
          :disabled="!isOnline"
        >
          <v-list-item-title>Base Serveur</v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="isLoggedIn"
          :to="{ name: 'projects-list-local' }"
        >
          <v-list-item-title>Base Tablette</v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="isLoggedIn && isPlanningVisible"
          :to="{ name: 'PlanningPage' }"
        >
          <v-list-item-title>Planning</v-list-item-title>
        </v-list-item>

        <v-list-item @click="checkUpdates">
          <v-list-item-title>Recherche mis à jour</v-list-item-title>
        </v-list-item>

        <v-list-item :to="{ name: 'release-notes' }">
          <v-list-item-title>Notes de version</v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <template v-slot:append>
      <p class="text-center">
        Version : 1.7.4
      </p>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "NavDrawer",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDrawer: this.show,

      appEnv: process.env.NODE_ENV
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "auth/isLoggedIn",
      userRole: "auth/getLoggedInUserRole"
    }),

    isPlanningVisible() {
      if (
        this.userRole === "CHIEF" ||
        this.userRole === "SUPER_ADMIN" ||
        this.userRole === "ADMIN"
      ) {
        return true;
      }
      return false;
    }
  },
  watch: {
    show: function(value) {
      this.showDrawer = value;
    },

    showDrawer: function() {
      this.$emit("input", this.showDrawer);
    }
  },

  methods: {
    // Check updates
    checkUpdates() {
      let root = this;

      console.log("Checking updates....");

      navigator.serviceWorker.getRegistrations().then(function(registrations) {
        for (var i = 0; i < registrations.length; i++) {
          console.log("registration found : asking for update");
          registrations[i].update();
        }
        root.$emit("input", false);
      });
    }
  }
};
</script>
